import { useReveal } from "@/hooks/useReveal";

const items = [
  {
    img: "https://images.unsplash.com/photo-1617814076231-2c58846db944",
    label: "Full Body Kit + Gloss Black Wrap",
    tag: "After",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    img: "https://images.unsplash.com/photo-1600793575654-910699b5e4d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxtb2RpZmllZCUyMG5lb24lMjBzcG9ydHMlMjBjYXIlMjBkYXJrfGVufDB8fHx8MTc4Mjc5Mjc0M3ww&ixlib=rb-4.1.0&q=85",
    label: "Custom Stance Build",
    tag: "Custom Build",
    span: "",
  },
  {
    img: "https://images.pexels.com/photos/11139244/pexels-photo-11139244.jpeg",
    label: "3-Stage Paint Correction",
    tag: "High Gloss",
    span: "",
  },
  {
    img: "https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg",
    label: "Ceramic Coating Application",
    tag: "Protection",
    span: "",
  },
  {
    img: "https://images.unsplash.com/photo-1532578498858-e21a39e0a449",
    label: "Matte Wrap Transformation",
    tag: "Before / After",
    span: "",
  },
];

const GarageItem = ({ item, idx }) => {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`garage-item-${idx}`}
      className={`reveal group relative overflow-hidden border border-[#262626] hover:border-[#FF4500]/60 transition-colors duration-300 ${item.span}`}
      style={{ animationDelay: `${idx * 0.1}s` }}
    >
      <img
        src={item.img}
        alt={item.label}
        className="w-full h-full object-cover min-h-[240px] transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
      <span className="absolute top-4 left-4 bg-[#FF4500] text-white text-xs font-bold uppercase tracking-widest px-3 py-1.5">
        {item.tag}
      </span>
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <p className="font-heading text-lg font-bold uppercase text-white tracking-tight">{item.label}</p>
      </div>
    </div>
  );
};

export const Garage = () => (
  <section id="garage" data-testid="garage-section" className="py-24 md:py-32 bg-[#0F0F0F]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="flex items-center gap-3 mb-6">
        <span className="h-px w-12 bg-[#FF4500]" />
        <span className="text-sm uppercase tracking-[0.3em] text-[#FF4500] font-semibold">Before / After</span>
      </div>
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight uppercase text-white">
          The Garage
        </h2>
        <p className="text-base md:text-lg text-neutral-400 max-w-md">
          Transformations, custom builds, and finishes so glossy you can check your reflection in them.
        </p>
      </div>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-4 auto-rows-[240px] gap-4">
        {items.map((item, idx) => (
          <GarageItem key={idx} item={item} idx={idx} />
        ))}
      </div>
    </div>
  </section>
);
